import { useState } from 'react';

// Sortable tables. Click a column header to sort by it (its "first"
// direction: highest first for most stats), again to flip it, and a third
// time to go back to the table's own order. Empty values always go last.
//
//   const sorter = useSortable();
//   const shown = sorter.apply(rows, { pts: r => r.pts, name: r => r.lName });
//   <SortTh k='pts' label='Pts' sorter={sorter} />
export function useSortable(initial = null) {
    const [ sort, setSort ] = useState(initial);

    const toggle = (key, first = 'desc') => setSort(s => {
        if (s?.key !== key) return { key, dir: first };
        if (s.dir === first) return { key, dir: first === 'desc' ? 'asc' : 'desc' };
        return null;
    });

    const apply = (rows, getters) => {
        const get = sort && getters[sort.key];
        if (!get) return rows;
        const sign = sort.dir === 'asc' ? 1 : -1;
        return [...rows].sort((a, b) => {
            const x = get(a);
            const y = get(b);
            const xNone = x === null || x === undefined || Number.isNaN(x);
            const yNone = y === null || y === undefined || Number.isNaN(y);
            if (xNone || yNone) return xNone - yNone;
            const c = typeof x === 'string' ? x.localeCompare(y) : x - y;
            return c * sign;
        });
    };

    return { sort, toggle, apply };
}
